/**
 * @generated SignedSource<<22f32d258e93c9ab21d646d57824d483>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceSignalEditScheduledArchiveAtArchiveMutation$variables = {
  workspaceSignalId: string;
};
export type WorkspaceSignalEditScheduledArchiveAtArchiveMutation$data = {
  readonly signalWorkspace: {
    readonly archive: {
      readonly archivedAtDate: {
        readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
      } | null;
      readonly id: string;
    };
  };
};
export type WorkspaceSignalEditScheduledArchiveAtArchiveMutation = {
  response: WorkspaceSignalEditScheduledArchiveAtArchiveMutation$data;
  variables: WorkspaceSignalEditScheduledArchiveAtArchiveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceSignalId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "workspaceSignalId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceSignalEditScheduledArchiveAtArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "archive",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "archivedAtDate",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "FormattedDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceSignalEditScheduledArchiveAtArchiveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SignalWorkspaceMutation",
        "kind": "LinkedField",
        "name": "signalWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SignalWorkspace",
            "kind": "LinkedField",
            "name": "archive",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "archivedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e6b181f7baf61905f18f44e330eb185f",
    "id": null,
    "metadata": {},
    "name": "WorkspaceSignalEditScheduledArchiveAtArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceSignalEditScheduledArchiveAtArchiveMutation(\n  $workspaceSignalId: ID!\n) {\n  signalWorkspace(id: $workspaceSignalId) {\n    archive {\n      id\n      archivedAtDate {\n        ...FormattedDate\n      }\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "a2ba844f943cfc62d4cdcba318a9db11";

export default node;
